var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedExtension(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bed extension ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bed-extension-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Height",
    transform: "translate(12.000000, 6.000000) rotate(-90.000000) translate(-12.000000, -6.000000) translate(10.000000, 3.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7,5.5 L3.3,5.5 C3.35522847,5.5 3.4,5.45522847 3.4,5.4 C3.4,5.37836298 3.39298221,5.35730962 3.38,5.34 L2.08,3.60666667 C2.04686292,3.56248389 1.98418278,3.55352958 1.94,3.58666667 C1.93241943,3.59235209 1.92568542,3.5990861 1.92,3.60666667 L0.62,5.34 C0.586862915,5.38418278 0.59581722,5.44686292 0.64,5.48 C0.657309617,5.49298221 0.678362979,5.5 0.7,5.5 Z",
    id: "Down",
    transform: "translate(2.000000, 4.500000) scale(1, -1) translate(-2.000000, -4.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.7,2.5 L3.3,2.5 C3.35522847,2.5 3.4,2.45522847 3.4,2.4 C3.4,2.37836298 3.39298221,2.35730962 3.38,2.34 L2.08,0.606666667 C2.04686292,0.562483887 1.98418278,0.553529582 1.94,0.586666667 C1.93241943,0.592352092 1.92568542,0.5990861 1.92,0.606666667 L0.62,2.34 C0.586862915,2.38418278 0.59581722,2.44686292 0.64,2.48 C0.657309617,2.49298221 0.678362979,2.5 0.7,2.5 Z",
    id: "Up"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.6234395,8.86666667 L1.37561322,8.86666667 C1.16862334,8.86666667 1,8.73854086 1,8.58009796 L1,7.28620779 C1,7.12848672 1.16862334,7 1.37561322,7 C1.58355043,7 1.75075278,7.12848672 1.75075278,7.28620779 L1.75075278,8.2942511 L14.2482999,8.2942511 L14.2482999,7.28620779 C14.2482999,7.12848672 14.4164496,7 14.6234395,7 C14.830903,7 15,7.12848672 15,7.28620779 L15,8.58009796 C15,8.73854086 14.830903,8.86666667 14.6234395,8.86666667",
    id: "Fill-75",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedExtension);
export default __webpack_public_path__ + "static/media/Bed_extension.b7e07c8b.svg";
export { ForwardRef as ReactComponent };